var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentInterestOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.688 4.188C5.229 5.646 4.5 7.417 4.5 9.5c0 1.35.338 2.6 1.013 3.75A7.642 7.642 0 008 15.845V18h8v-2.155a7.65 7.65 0 002.488-2.595A7.28 7.28 0 0019.5 9.5c0-2.083-.73-3.854-2.188-5.312C15.854 2.729 14.083 2 12 2s-3.854.73-5.312 2.188zm10.075 8.05c.492-.84.737-1.74.737-2.738 0-1.559-.523-2.819-1.602-3.897C14.82 4.523 13.558 4 12 4c-1.559 0-2.819.523-3.897 1.602C7.023 6.68 6.5 7.942 6.5 9.5c0 .998.245 1.898.738 2.737a5.645 5.645 0 001.844 1.927l.918.59V16h4v-1.246l.918-.59a5.65 5.65 0 001.845-1.926zM11.998 20H10c0 .55.196 1.021.588 1.413.391.391.862.587 1.412.587a1.93 1.93 0 001.413-.587A1.93 1.93 0 0014 20h-2.002z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentInterestOutline);
export default __webpack_public_path__ + "8b1bbc375cbc56f126c99aebf21e5490.svg";
export { ForwardRef as ReactComponent };